import { render, staticRenderFns } from "./RoomsReserve.vue?vue&type=template&id=1b104b4e&"
import script from "./RoomsReserve.vue?vue&type=script&lang=js&"
export * from "./RoomsReserve.vue?vue&type=script&lang=js&"
import style0 from "./RoomsReserve.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports